import script from "./DashboardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardComponent.vue?vue&type=style&index=0&id=73544126&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73544126"]])

export default __exports__